import { RoleType } from './role-api';
import { baseFetch } from './utils.ts/base-fetch';

export const managerApiUrl = '/protected/manager';

export type UserRole = 'admin_head' | 'admin_branch';

export type UserType = {
  additional_emails: string[];
  additional_phones: string[];
  area: string;
  city: string;
  country: string;
  email: string;
  login: string;
  phone: string;
  first_name: string;
  second_name: string;
  last_name: string;
  permissions: RoleType['permissions'];
  role?: UserRole;
  id?: string;
  created_at?: string;
  is_deleted?: boolean;
};

export const fetchManagerProfile = async (): Promise<UserType> => {
  const response = await baseFetch(`${managerApiUrl}/me/profile/user`);
  return response;
};

export const putManagerProfile = async (data: Partial<UserType>): Promise<UserType> => {
  const response = await baseFetch(`${managerApiUrl}/me/profile/user`, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
  return response;
};
